<template>
  <div class="charts-section">
    <div class="chart-block">
      <label>Companies</label>
      <bar-chart :chartdata="companiesCountData" :height="60"/>
      <span class="chart-value">
        <b>{{ inBoundsCompaniesCount }}</b>
        / {{ allCompaniesCount }}
      </span>
    </div>
    <div class="chart-block">
      <label>Development projects</label>
      <bar-chart :chartdata="projectsCountData" :height="60"/>
      <span class="chart-value">
        <b>{{ inBoundsProjectsCount }}</b>
        / {{ allProjectsCount }}
      </span>
    </div>
    <div class="chart-block">
      <label>Companies size by revenue</label>
      <revenue-chart />
    </div>
    <div class="chart-block">
      <label>Total projects budget</label>
      <bar-chart :chartdata="projectsBudgetData" :height="60"/>
      <span class="chart-value">
        <b>{{ formattedBudgets.selected }}</b>
        / {{ formattedBudgets.total }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import numbro from 'numbro'
import BarChart from '@/components/charts/bar-chart'
import RevenueChart from '@/components/charts/companies-revenue-chart'

export default {
  name: 'charts-section',
  components: {
    BarChart,
    RevenueChart,
  },
  computed: {
    ...mapGetters({
      inBoundsCompaniesCount: 'companies/inBoundsCompaniesCount',
      allCompaniesCount: 'companies/allCompaniesCount',
      inBoundsProjectsCount: 'projects/inBoundsProjectsCount',
      allProjectsCount: 'projects/allProjectsCount',
      inBoundsProjectsBudget: 'projects/inBoundsProjectsBudget',
      allProjectsBudget: 'projects/allProjectsBudget',
    }),
    companiesCountData() {
      const data = {
        labels: ['Selected companies', 'All companies'],
        datasets: [
          {
            data: [this.inBoundsCompaniesCount, this.allCompaniesCount],
            backgroundColor: ['#59B451', '#C6E5C3'],
          },
        ],
      }
      return data
    },
    projectsCountData() {
      const data = {
        labels: ['Selected projects', 'All projects'],
        datasets: [
          {
            data: [this.inBoundsProjectsCount, this.allProjectsCount],
            backgroundColor: ['#FFD02C', '#FFF1BE'],
          },
        ],
      }
      return data
    },
    projectsBudgetData() {
      const data = {
        labels: ['Selected projects', 'All projects'],
        datasets: [
          {
            data: [this.inBoundsProjectsBudget, this.allProjectsBudget],
            backgroundColor: ['#de7062', '#e7d090'],
          },
        ],
      }
      return data
    },
    formattedBudgets() {
      const currencyFormat = {
        average: true,
        mantissa: 2,
        optionalMantissa: true,
        currencyPosition: 'prefix',
      }
      return {
        total: `$${numbro(this.allProjectsBudget).format(currencyFormat)}`,
        selected: `$${numbro(this.inBoundsProjectsBudget).format(
          currencyFormat
        )}`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.charts-section {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 20px;
}
.chart-block {
  position: relative;
  width: 185px;
  label {
    color: #8f949a;
    display: inline-block;
    font-size: 12px;
    padding-left: 10px;
    margin-bottom: 15px;
  }
  & ::v-deep canvas {
    position: relative;
    z-index: 10;
  }
}
.chart-value {
  color: #8f949a;
  position: absolute;
  left: 10px;
  bottom: 10px;
  font-size: 14px;
  b {
    color: #333;
  }
}
</style>
